export default "__VITE_ASSET__CsObu1o4__"